/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const normalize = (value: string | number | any) => {
  if (typeof value === "string") {
    // conditions to skip normalization.
    const isEmptyString = value.replaceAll(" ", "") === "";
    if (isEmptyString) return value;
    // If it is a stringfied number.
    if (Number.isInteger(+value)) {
      return Number(value);
    } else {
      return value.toLowerCase();
    }
  }
  return value;
};
export default normalize;
